import { render, staticRenderFns } from "./jump.vue?vue&type=template&id=63b22b5c&scoped=true"
import script from "./jump.vue?vue&type=script&lang=js"
export * from "./jump.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b22b5c",
  null
  
)

export default component.exports